import { orderBy, uniq } from 'lodash';
import { Hierarchy } from "../../../../../../../common";
import type { IDimensionItemDTO } from "../../../../../../api";

export function not(a: unknown[], b: unknown[]) {
  return a.filter((value) => b.indexOf(value) === -1);
}

export function intersection(a: unknown[], b: unknown[]) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

export function createSelection(
  selection: (string | number)[], 
  itemId: string | number, 
  hierarchies: Hierarchy<string | number, IDimensionItemDTO<string | number>>[]
): (string | number)[] {
  const flatHierarchies = Hierarchy.flat<string | number, IDimensionItemDTO<string | number>>(hierarchies);
  const targetHierarchyItem = flatHierarchies.find(h => h.id === itemId);
  const childrenIds = targetHierarchyItem?.flatChildren.map(c => c.id) ?? [];

  if (selection.includes(itemId)) {
    return selection.filter((s) => s !== itemId && !childrenIds.includes(s));
  }
  if (targetHierarchyItem?.parent?.children.every(c => selection.includes(c.id) || itemId === c.id)) {
    return [...selection, targetHierarchyItem.parent.id, itemId, ...childrenIds];
  }
  return [...selection, itemId, ...childrenIds];
}

export function createHierarchies(items: IDimensionItemDTO<string | number>[], searchValue?: string) {
  let hierarchies = Hierarchy.from<string | number, IDimensionItemDTO<string | number>>(items);
  if (searchValue) {
    return Hierarchy.search(hierarchies, searchValue);
  }
  return hierarchies;
}

export function createCandidatesHierarchies(selection: (string | number)[], hierarchies: Hierarchy<unknown, IDimensionItemDTO<string | number>>[]) {
  const flatHierarchies = Hierarchy.flat(hierarchies);
  const flatCandidateHierarchyItems = flatHierarchies.filter(h => !selection.includes(h.id as string | number) && h.children.length === 0);
  const candidateItems = flatCandidateHierarchyItems.flatMap(it => {
    const parents = it.flatParents.map(p => p.origin);
    const children = it.flatChildren.map(p => p.origin);
    
    return [it.origin, ...parents, ...children];
  });
  const orderedCandidateItems = orderBy(uniq(candidateItems), it => it.order);
  const candidatesHierarchies = createHierarchies(orderedCandidateItems);
  return candidatesHierarchies;
}

export function createSelectedHierarchies(selection: (string | number)[], hierarchies: Hierarchy<unknown, IDimensionItemDTO<string | number>>[]) {
  const flatHierarchies = Hierarchy.flat(hierarchies);
  const flatSelectedHierarchyItems = flatHierarchies.filter(h => selection.includes(h.id as string | number));
  const selectedItems = flatSelectedHierarchyItems.flatMap(it => {
    const parents = it.flatParents.map(p => p.origin);
    const children = it.flatChildren.map(p => p.origin);
    
    return [it.origin, ...parents, ...children];
  });
  const orderedSelectdItems = orderBy(uniq(selectedItems), it => it.order);
  const selectedHierarchies = createHierarchies(orderedSelectdItems);
  return selectedHierarchies;
}